<div class="center">
    <cds-button size="sm" action="outline" [disabled]="isSharedCase" (click)="logout()"
        >Logout</cds-button
    >
</div>
